import React from 'react';
import {labels} from '../../../../../../util/utils';
import Utility from '../../../../../../util/utilityfunctions';
import {dashboardChartColors} from '../../../../../../util/uiconstants';

export default (
	formatId,
	total,
	taskOpen,
	taskOpenOverdue,
	numberFormat,
	taskOpenPercent,
	taskInProgress,
	taskInProgressPercent,
	taskInReview,
	taskInReviewPercent,
	taskComplete,
	taskCompletePercent
) => {
	const getTooltipText = (label, value, percent) => {
		return `${label} | ${Utility.getFormattedNumber(numberFormat, value)} (${percent}%)`;
	};

	const getFormattedTaskOpenOverdueCountText = `${Utility.getFormattedNumber(numberFormat, taskOpenOverdue)} ${
		labels.overdue
	}`;

	const data = {
		chartsData: [
			{
				barStyling: {
					chartWidth: 240,
					// chartHeight: 240,
					styleName: 'groupReportItem',
					chartWrapper: 'groupAuditchart',
					tooltipBorderColor: 'grey',
					tooltipBackground: 'white',
					styleBarcountClass: 'group-audit-count-wrap'
				},
				headerText: labels.pendingResponse,
				numberFormat: formatId,
				barMaxValue: total,
				showBarTitleTip: true,
				barItems: [
					{
						count: taskOpen,
						label: labels.open,
						statusClass: 'open motif-body2-default-regular',
						color: dashboardChartColors.blue[0],
						warningMessage: (
							<span className="motif-body3-default-light" title={getFormattedTaskOpenOverdueCountText}>
								{taskOpenOverdue > 0 ? getFormattedTaskOpenOverdueCountText : ''}
							</span>
						),
						toolTip: getTooltipText(labels.open, taskOpen, taskOpenPercent)
					}
				]
			},
			{
				barStyling: {
					chartWidth: 240,
					styleName: 'groupReportItem',
					chartWrapper: 'groupAuditchart',
					tooltipBorderColor: 'grey',
					tooltipBackground: 'white',
					styleBarcountClass: 'group-audit-count-wrap'
				},
				headerText: labels.received,
				numberFormat: formatId,
				barMaxValue: total,
				showBarTitleTip: true,
				barItems: [
					{
						count: taskInProgress,
						label: labels.inProgress,
						statusClass: 'inProgress motif-body2-default-regular',
						color: dashboardChartColors.blue[1],
						toolTip: getTooltipText(labels.inProgress, taskInProgress, taskInProgressPercent)
					},
					{
						count: taskInReview,
						label: labels.inReview,
						statusClass: 'inReview motif-body2-default-regular',
						color: dashboardChartColors.blue[2],
						toolTip: getTooltipText(labels.inReview, taskInReview, taskInReviewPercent)
					},
					{
						count: taskComplete,
						label: labels.completeUpperCase,
						statusClass: 'complete motif-body2-default-regular',
						color: dashboardChartColors.blue[3],
						toolTip: getTooltipText(labels.completeUpperCase, taskComplete, taskCompletePercent)
					}
				]
			}
		],
		total: total
	};
	return data;
};
